import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { ScrollToTop } from './ScrollToTop'
import { BottomNavigation } from './BottomNavigation'
import { HistoryProvider } from '@/contexts/HistoryContext'
import { ErrorBoundary } from '@/components/ErrorBoundary'

export function MainLayout() {
  return (
    <HistoryProvider>
      <div className="min-h-screen bg-background">
        <ScrollToTop />
        <Header />
        <div className="flex min-h-screen">
          <Sidebar />
          <main className="flex-1 p-4 sm:p-6 lg:p-8 w-full min-w-0 pb-20 lg:pb-8">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
        <BottomNavigation />
      </div>
    </HistoryProvider>
  )
}
